'use client'

import { useEffect } from 'react'

/**
 * Marks the document once the page has scrolled past the announcement bar.
 *
 * Renders nothing. It sets `data-scrolled` on `<html>`, and the header's
 * shadow is a CSS rule keyed off that attribute — so the header itself stays
 * a server component and no part of the navigation re-renders on scroll.
 *
 * Deliberately not a scroll-direction hide/show: navigation that moves out
 * from under the pointer is worse than navigation that stays put. The header
 * never resizes either, so nothing below it shifts.
 *
 * `passive: true` keeps the listener off the scrolling critical path, and the
 * attribute is only touched when the boolean actually flips.
 */
export function HeaderScroll() {
  useEffect(() => {
    const root = document.documentElement
    let scrolled = false

    const update = () => {
      const next = window.scrollY > 24
      if (next === scrolled) return
      scrolled = next
      root.toggleAttribute('data-scrolled', next)
    }

    update()
    window.addEventListener('scroll', update, { passive: true })
    return () => {
      window.removeEventListener('scroll', update)
      root.removeAttribute('data-scrolled')
    }
  }, [])

  return null
}
